export default "__VITE_ASSET__BRDvjg09__"